"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vocabularyModuleKey = exports.Skill = void 0;
var Skill;
(function (Skill) {
    Skill["define"] = "define";
    Skill["say"] = "say";
    Skill["recognise"] = "recognise";
    Skill["spell"] = "spell";
    Skill["identifySynonyms"] = "identifySynonyms";
    Skill["identifyAntonyms"] = "identifyAntonyms";
    Skill["useInASentence"] = "useInASentence";
    Skill["useWordClasses"] = "useWordClasses";
})(Skill = exports.Skill || (exports.Skill = {}));
const moduleSortKey = (moduleId) => `module#${moduleId}`;
const vocabularyModuleKey = (wordId, moduleId) => ({
    wordId,
    sk: moduleSortKey(moduleId)
});
exports.vocabularyModuleKey = vocabularyModuleKey;
//# sourceMappingURL=VocabularyModule.js.map